import { InfiniteData } from "@tanstack/react-query"
import { GetTicketsByFiltersDtoIPagedEnumerableProps } from "api/Schemas/GetTicketsByFiltersDtoIPagedEnumerable"
import { ProgressSpinner } from "primereact/progressspinner"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"

interface MobileTicketsProps {
  data:
    | InfiniteData<GetTicketsByFiltersDtoIPagedEnumerableProps, unknown>
    | undefined
  isFetchingNextPage: boolean
  loadMoreRef: React.RefObject<HTMLDivElement>
  onClick: (ticketId: string) => void
}

const MobileListTickets = ({
  data,
  isFetchingNextPage,
  loadMoreRef,
  onClick,
}: MobileTicketsProps) => {
  return (
    <div className='tw-p-4 sm:tw-mx-auto sm:tw-max-w-lg'>
      {data?.pages?.map(
        (tickets: GetTicketsByFiltersDtoIPagedEnumerableProps) => {
          return tickets?.items?.map((ticket) => {
            return (
              <div
                key={ticket?.id}
                onClick={() => ticket?.id && onClick(ticket.id)}
                className='tw-bg-simple-10 tw-w-full tw-h-auto tw-p-3 tw-mb-2 tw-rounded hover:tw-shadow'
              >
                <div className='tw-flex tw-justify-between tw-cursor-pointer tw-w-full'>
                  <div className='tw-flex tw-justify-center'>
                    <div className='tw-mr-2 tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-bg-neutral-10 tw-rounded'>
                      <span>
                        {ticket.categoria?.icono === null
                          ? "🏷️"
                          : ticket.categoria?.icono}
                      </span>
                    </div>

                    <div className='tw-flex-col tw-text-left'>
                      <p className='tw-font-medium tw-text-sm'>
                        {ticket?.nombre}
                      </p>
                      <span className='tw-text-info-100 tw-text-xs tw-font-medium'>
                        {ticket.categoria?.nombre}
                      </span>
                    </div>
                  </div>
                  <div className='tw-flex tw-flex-col tw-items-end tw-justify-center'>
                    <p className='tw-text-neutral-75 tw-text-xs'>
                      {ticket?.fechaEmision
                        ? frontendDateFormat(new Date(ticket.fechaEmision))
                        : ""}
                    </p>
                    <p className='tw-text-sm tw-font-medium'>
                      {ticket?.importe ? frontendCurrency(ticket?.importe) : ""}
                    </p>
                  </div>
                </div>
              </div>
            )
          })
        }
      )}
      <div
        ref={loadMoreRef}
        className='tw-h-8 tw-flex tw-justify-center tw-items-center'
      >
        {isFetchingNextPage && <ProgressSpinner className='tw-w-7 tw-h-7' />}
      </div>
    </div>
  )
}

export default MobileListTickets
